import { CountryService } from './../../../core/services/country.service';
import { ModelService } from 'src/app/core/services/model.service';
import { Subscription } from 'rxjs';
import { CmsService } from 'src/app/core/services/cms.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { CustomerService } from './../../../core/services/customer.service';
import { TbAuthService, OperationResult } from '@tb/auth';
import { Customer } from 'src/app/model/customer';
import { LoadingService } from 'src/app/core/services/loading.service';
import * as _ from 'lodash';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Country } from 'src/app/core/services/country.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { MiGenParameters } from 'src/app/model/MiGenParameters';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { debounceTime } from 'rxjs/operators';
import { VatNumberService } from 'src/app/core/services/vatnumber.service';

@Component({
    selector: 'ms-dati-fatturazione',
    templateUrl: './dati-fatturazione.component.html',
    styleUrls: ['./dati-fatturazione.component.scss'],
})
export class DatiFatturazioneComponent implements OnInit, AfterViewChecked {
    c: Customer;
    @ViewChild('mainDataForm', { static: true }) signupForm: NgForm;
    selectableCountries: Country[] = [];
    disableAllFields: boolean = false;
    formIsDisabled = false;
    subtitle_1: string;
    subtitle_2: string;
    public cmsObj: CmsObject[];
    public disableSaveButton = false;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    componentIsInitialized: boolean = false;
    public loading: boolean = false;
    public customerSaved: boolean = false;
    public placeholder: string;
    sCustomer: Subscription;
    sCompanyInfo: Subscription;

    @Input() imInSubscriptionsManagement: boolean;
    @Input() setReadOnly: boolean;
    @Input() showOnlySubscriberMasterData: boolean;
    @Input() title: boolean;
    @Output() cannotProceed = new EventEmitter<boolean>();
    @Output() customerExists = new EventEmitter<boolean>();
    @Input() subscriptionKey: string = '';
    @Input() industryCode: string = '';
    @Input() showPartnerCodeField = false;
    // @Input() isUpdate: string;
    @Input() isSubNfs: boolean;

    vatNumber: FormControl;
    sectionIsDisabled: boolean = false;
    showWarning = false;
    showVATNumber = false;
    warning = '';

    constructor(
        public customerService: CustomerService,
        private tbAuthService: TbAuthService,
        private loginService: LoginService,
        public workFlow: WorkFlowService,
        private cmsService: CmsService,
        private variable: TranslatedVariables,
        public loadingService: LoadingService,
        public serviceUtilsService: ServiceUtilsService,
        public countryService: CountryService,
        private vatNumberService: VatNumberService
    ) {
        this.c = new Customer();
        this.vatNumber = new FormControl('', [Validators.required, Validators.maxLength(20)]);
    }

    async ngOnInit() {
        this.selectableCountries = [];
        this.selectableCountries = this.countryService.getCountries();
        this.update();
        this.componentIsInitialized = true;
        this.vatNumber.valueChanges.pipe(debounceTime(1000)).subscribe(async (res) => {
            if (this.vatNumber.value === '') {
                this.showWarning = false;
                return;
            }
            this.checkVATNumber();
        });
    }

    ngOnChanges() {
        if (this.componentIsInitialized) {
            this.update();
        }
    }

    ngAfterViewChecked() {
        if (!this.showOnlySubscriberMasterData) {
            if (this.setReadOnly) {
                if (this.signupForm.form) {
                    this.signupForm.form.disable();
                    this.vatNumber.disable();
                    this.formIsDisabled = true;
                    this.signupForm.form.markAsUntouched();
                    this.signupForm.form.markAsPristine();
                    this.signupForm.form.clearValidators();
                    this.signupForm.form.updateValueAndValidity();
                }
            }
        }
    }
    async getCmsObj() {
        const lang = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(lang, 'datifatturazione');
        this.cmsObj = await this.cmsService.getCmsObj(lang, 'emailvalidation');
        this.subtitle_1 = this.cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_1').ContentTranslation;
        this.subtitle_2 = this.cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_2').ContentTranslation;
    }

    async cancel() {
        this.signupForm.form.markAsUntouched();
        this.signupForm.form.markAsPristine();
        this.showVATNumber = false;
        this.showWarning = false;
        this.vatNumber.setValue('');
        this.update();
    }
    public convertToUpperCase(val: string) {
        if (val) return val.toUpperCase();
        else return '';
    }

    async save() {
        try {
            this.c.SubscriptionKey = this.subscriptionKey;
            this.c.AccountName = this.tbAuthService.getAccountName().trim();
            this.sCompanyInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
                if (!companyInfo) {
                    return;
                }
            });

            this.loading = true;
            this.loadingService.setLoading(this.loading);

            let opResult: OperationResult = await this.customerService.saveCustomer(this.c, true);
            this.disableSaveButton = opResult.Result;
            if (!opResult.Result) {
                this.disableSaveButton = false;
                this.workFlow.showMessage(this.variable.errorTitle, opResult.Message);
                this.loginService.logOff$.next();
                this.loading = false;
                this.loadingService.setLoading(this.loading);
            } else {
                this.customerSaved = true;
                this.c = opResult.Content as Customer;
                this.signupForm.form.markAsUntouched();
                this.signupForm.form.markAsPristine();
                this.customerService.customer = this.c;
                this.customerService.customer$.next(this.c);

                this.loading = false;
                this.loadingService.setLoading(this.loading);
                this.cannotProceed.emit(false);
            }
        } catch (err) {
            this.workFlow.showMessage(this.variable.errorTitle, err.message);
            this.cannotProceed.emit(true);
            this.disableSaveButton = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
        }
    }

    public async setRequired() {
        this.showVATNumber = true;
        if (!this.vatNumber.value || !this.vatNumber.value.replace(/\s/g, '').length) {
            this.disableSaveButton = true;
            this.vatNumber.setValidators(Validators.required);
            this.vatNumber.updateValueAndValidity();
            this.vatNumber.markAsDirty({ onlySelf: true });
            this.vatNumber.markAsTouched({ onlySelf: true });
            this.vatNumber.markAsPristine({ onlySelf: true });
        } else {
            //this.vatNumber.value
            this.checkVATNumber();
        }
        if (this.c.Country.trim() == 'IT') {
            if (this.signupForm.controls['FiscalCode']) {
                this.signupForm.controls['FiscalCode'].setValidators(Validators.required);
                this.signupForm.controls['FiscalCode'].updateValueAndValidity();
                this.signupForm.controls['FiscalCode'].markAsDirty({ onlySelf: true });
                this.signupForm.controls['FiscalCode'].markAsTouched({ onlySelf: true });
                this.signupForm.controls['FiscalCode'].markAsPristine({ onlySelf: true });
            }
        } else {
            //
            if (this.signupForm.controls['FiscalCode']) {
                this.signupForm.controls['FiscalCode'].clearAsyncValidators;
                this.signupForm.controls['FiscalCode'].updateValueAndValidity();
                this.signupForm.controls['FiscalCode'].markAsUntouched({ onlySelf: true });
            }

            this.disableSaveButton = false;
        }
    }

    ngOnDestroy() {
        if (this.sCompanyInfo) this.sCompanyInfo.unsubscribe();
        if (this.sCustomer) this.sCustomer.unsubscribe();
    }

    async update() {
        this.getCmsObj();
        let opRes: OperationResult = await this.serviceUtilsService.getStoreParameterValue('fillFieldsButton');
        let content = new MiGenParameters();
        content = opRes.Content as MiGenParameters;
        this.sectionIsDisabled = content.Disabled;

        //se la subscriptionkey è vuota siamo in caso slave o nuovo acquisto
        let c: Customer = new Customer();
        this.c = c;
        this.cannotProceed.emit(this.c.VATNumber?.trim().length == 0);
        this.customerExists.emit(this.c.VATNumber?.trim().length != 0);

        if (this.setReadOnly) {
            if (this.signupForm.form) {
                this.signupForm.form.disable();
                this.vatNumber.disable();
                this.formIsDisabled = true;
                this.signupForm.form.markAsUntouched();
                this.signupForm.form.markAsPristine();
                this.signupForm.form.clearValidators();
                this.signupForm.form.updateValueAndValidity();
                this.disableSaveButton = true;
            }
        }
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.setRequired();
    }

    public setFieldReadOnly() {
        if (this.signupForm.controls) {
            if (this.signupForm.controls['CompanyName']) this.signupForm.controls['CompanyName'].disable();
            if (this.signupForm.controls['FiscalCode']) this.signupForm.controls['FiscalCode'].disable();
            if (this.signupForm.controls['VATNumber']) this.signupForm.controls['VATNumber'].disable();
            if (this.signupForm.controls['Country']) this.signupForm.controls['Country'].disable();
        }
    }

    public enableSaveButton() {
        this.disableSaveButton = false;
    }

    showCountryWarning(country: string) {
        switch (country) {
            case 'DK':
            case 'SI':
            case 'FI':
                this.warning = `${this.variable.invalidVATNumberDesc1} 8 ${this.variable.invalidVATNumberDesc4}`;
                break;
            case 'LU':
            case 'MT':
            case 'HU':
                this.warning = `${this.variable.invalidVATNumberDesc1} 8 ${this.variable.invalidVATNumberDesc2}`;
                break;
            case 'EL':
            case 'PT':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9 ${this.variable.invalidVATNumberDesc4}`;
                break;
            case 'EE':
            case 'DE':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9 ${this.variable.invalidVATNumberDesc2}`;
                break;
            case 'HR':
            case 'LV':
                this.warning = `${this.variable.invalidVATNumberDesc1} 11 ${this.variable.invalidVATNumberDesc2}`;
                break;
            case 'IT':
                this.warning = `${this.variable.invalidVATNumberDesc1} 11 ${this.variable.invalidVATNumberDesc4}`;
                break;
            case 'CY':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9 ${this.variable.invalidVATNumberDesc3}`;
                break;
            case 'LT':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9-12 ${this.variable.invalidVATNumberDesc2}`;
                // 9 o 12
                break;
            case 'CZ':
                this.warning = `${this.variable.invalidVATNumberDesc1} 8-10 ${this.variable.invalidVATNumberDesc2}`;
                // 8, 9 o 10 cifre
                break;
            case 'BG':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9-10 ${this.variable.invalidVATNumberDesc2}`;
                // 9 o 10 cifre
                break;
            case 'AT':
                this.warning = `${this.variable.invalidVATNumberDesc1} ${this.variable.invalidVATNumberDesc6} U + 8 ${this.variable.invalidVATNumberDesc2}`;
                // Lettera U + 8 cifre
                break;
            case 'SE':
                this.warning = `${this.variable.invalidVATNumberDesc1} 12 ${this.variable.invalidVATNumberDesc5}`;
                break;
            case 'SK':
                this.warning = `${this.variable.invalidVATNumberDesc1} 10 ${this.variable.invalidVATNumberDesc2}`;
                break;
            case 'RO':
                this.warning = `${this.variable.invalidVATNumberDesc1} 2-10 ${this.variable.invalidVATNumberDesc4}`;
                // 2 - 10 cifre(l'ultima cifra è un numero di controllo)
                break;
            case 'PL':
                this.warning = `${this.variable.invalidVATNumberDesc1} 10 ${this.variable.invalidVATNumberDesc4}`;
                break;
            // MULTIPLI
            case 'BE':
                this.warning = `${this.variable.invalidVATNumberDesc1} ${this.variable.invalidVATNumberDesc10}`;
                break;
            case 'FR':
                this.warning = `${this.variable.invalidVATNumberDesc1} ${this.variable.invalidVATNumberDesc7}`;
                break;
            case 'IE':
                this.warning = `${this.variable.invalidVATNumberDesc1} ${this.variable.invalidVATNumberDesc9}`;
                break;
            case 'NL':
                this.warning = `${this.variable.invalidVATNumberDesc1} 11 ${this.variable.invalidVATNumberDesc2} + ${this.variable.invalidVATNumberDesc6} B`;
                break;
            case 'ES':
                this.warning = `${this.variable.invalidVATNumberDesc1} ${this.variable.invalidVATNumberDesc8}`;
                break;
            case 'GB':
                this.warning = `${this.variable.invalidVATNumberDesc1} 9 ${this.variable.invalidVATNumberDesc2}`;
                break;
            default:
                this.warning = this.variable.invalidVATNumber;
        }
    }

    checkVATNumber() {
        this.checkEmptyVatNr();
        this.showWarning = !this.vatNumberService.isTaxIdValid(this.vatNumber.value, this.c.Country.trim());
        if (this.showWarning) {
            this.showCountryWarning(this.c.Country.trim());
        }
    }

    onClick(country: string) {
        switch (country) {
            case 'IT':
                return 'https://telematici.agenziaentrate.gov.it/VerificaPIVA/Scegli.do?parameter=verificaPiva';
            case 'GB':
                return 'https://www.tax.service.gov.uk/check-vat-number/enter-vat-details';
        }
    }
    public checkEmptyVatNr() {
        if (this.vatNumber.value.replace(/\s/g, '').length == 0) {
            this.disableSaveButton = true;
            this.vatNumber.setValidators(Validators.required);
            this.vatNumber.updateValueAndValidity();
            this.vatNumber.markAsDirty({ onlySelf: true });
            this.vatNumber.markAsTouched({ onlySelf: true });
            this.vatNumber.markAsPristine({ onlySelf: true });
            return false;
        } else {
            this.disableSaveButton = false;
            return true;
        }
    }
}

export class CountryInfo {
    dialCode: string;
    iso2: string;
    name: string;
}
